import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../common/html/element'
import { Icon } from '../../common/html/icon'
import { selectTopicActive } from '../store/slice'

const TextActionBubble = ({
  isOpen,
  setQuestionReply,
  messageInputRef,
  chatbotBodyRef,
  popupRef,
}) => {
  const mousePositionRef = useRef({ x: 0, y: 0 })
  const topicActive = useSelector(selectTopicActive)

  const [selectionPopover, setSelectionPopover] = useState({
    visible: false,
    top: 0,
    left: 0,
    text: '',
  })

  const handleSelectionPopoverClick = () => {
    if (!selectionPopover.text) return
    setQuestionReply(selectionPopover.text)
    setSelectionPopover((prev) => ({ ...prev, visible: false }))
    if (messageInputRef.current) {
      messageInputRef.current.focus()
    }
  }

  useEffect(() => {
    if (!isOpen) return

    const bodyEl = chatbotBodyRef.current
    const popupEl = popupRef.current
    if (!bodyEl || !popupEl) return

    let isMouseDown = false

    const hidePopover = () => {
      setSelectionPopover((prev) =>
        prev.visible ? { ...prev, visible: false } : prev,
      )
    }

    const computeAndShowPopover = () => {
      const selection = window.getSelection()
      if (!selection || selection.rangeCount === 0 || selection.isCollapsed) {
        hidePopover()
        return
      }

      const range = selection.getRangeAt(0)
      const containerNode =
        range.commonAncestorContainer.nodeType === 3
          ? range.commonAncestorContainer.parentNode
          : range.commonAncestorContainer
      const messageEl = containerNode.closest('.message')

      if (
        !chatbotBodyRef.current ||
        !chatbotBodyRef.current.contains(containerNode) ||
        !messageEl?.classList.contains('ai')
      ) {
        hidePopover()
        return
      }

      const text = selection.toString().trim()
      if (!text) {
        hidePopover()
        return
      }

      const popupRect = popupEl.getBoundingClientRect()

      let top = mousePositionRef.current.y - popupRect.top + 10
      let left = mousePositionRef.current.x - popupRect.left + 80

      const minLeft = 20
      const maxLeft = popupRect.width - 160
      const minTop = 20
      const maxTop = popupRect.height - 60

      left = Math.max(minLeft, Math.min(left, maxLeft))
      top = Math.max(minTop, Math.min(top, maxTop))

      setSelectionPopover({ visible: true, top, left, text })
    }

    const onMouseDown = (e) => {
      if (bodyEl.contains(e.target)) {
        isMouseDown = true
        hidePopover()
      }
    }

    const onMouseUp = (e) => {
      if (!isMouseDown) return
      isMouseDown = false
      mousePositionRef.current = { x: e.clientX, y: e.clientY }
      computeAndShowPopover()
    }

    const onSelectionChange = () => {
      const selection = window.getSelection()
      if (!selection || selection.rangeCount === 0 || selection.isCollapsed) {
        hidePopover()
      }
    }

    bodyEl.addEventListener('mousedown', onMouseDown)
    bodyEl.addEventListener('mouseup', onMouseUp)
    document.addEventListener('selectionchange', onSelectionChange)
    window.addEventListener('scroll', hidePopover, true)

    return () => {
      bodyEl.removeEventListener('mousedown', onMouseDown)
      bodyEl.removeEventListener('mouseup', onMouseUp)
      document.removeEventListener('selectionchange', onSelectionChange)
      window.removeEventListener('scroll', hidePopover, true)
    }
  }, [isOpen])

  if (!selectionPopover.visible || !topicActive?.topicId) return <></>

  return (
    <Element
      className="selection-popover"
      style={{
        top: selectionPopover.top,
        left: selectionPopover.left,
        fontSize: 14,
        position: 'absolute',
      }}
      onMouseDown={(e) => e.preventDefault()}
      onClick={handleSelectionPopoverClick}
    >
      <Icon className="icon-conversation" style={{ fontSize: 20 }} />
      <Translate value="chatbot.ASK_FIIN_GATE_ASSISTANT" />
    </Element>
  )
}

export default TextActionBubble
